<div class="form-inline">
  <nb-select
    outline
    shape="round"
    size="small"
    status="info"
    class="period-select"
    [(ngModel)]="typeSelected"
    (selectedChange)="changePeriod($event)"
  >
    <nb-option *ngFor="let period of types" [value]="period.value">
      {{ period.title }}
    </nb-option>
    <!-- <nb-option *ngIf="mode === 'dept'" value="now">Hiện tại</nb-option>
    <nb-option value="today">{{ "period.today" | translate }}</nb-option>
    <nb-option value="yesterday">
      {{ "period.yesterday" | translate }}
    </nb-option>    
    <nb-option value="thisMonth">
      {{ "period.thisMonth" | translate }}
    </nb-option>
    <nb-option value="lastMonth">
      {{ "period.lastMonth" | translate }}
    </nb-option>
    <nb-option value="custom">{{ "period.custom" | translate }}</nb-option>
    <nb-option *ngIf="allowAll" value="allTime">{{
      "period.allTime" | translate
    }}</nb-option> -->
  </nb-select>

  <nb-form-field *ngIf="type === 'custom'" style="width: 120px">
    <input
      nbInput
      shape="semi-round"
      placeholder="Chọn từ ngày"
      [nbDatepicker]="pickFromDate"
      [(ngModel)]="fromDate"
    />
    <nb-datepicker #pickFromDate format="dd/MM/yyyy"></nb-datepicker>
  </nb-form-field>

  <nb-form-field *ngIf="type === 'custom'" style="width: 120px">
    <input
      nbInput
      shape="semi-round"
      placeholder="Chọn đến ngày"
      [nbDatepicker]="pickToDate"
      [(ngModel)]="toDate"
    />
    <nb-datepicker #pickToDate format="dd/MM/yyyy"></nb-datepicker>
  </nb-form-field>

  <button
    *ngIf="type === 'custom'"
    nbButton
    outline
    shape="semi-round"
    status="info"
    size="small"
    (click)="selectedPeriod()"
  >
    {{ "buttons.view" | translate }}
  </button>
</div>
